import { ChangeDetectionStrategy, Component, effect, input, output, signal, viewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonCtaComponent } from '@components/button-cta/button-cta.component';
import { VoiceMicInputComponent } from '@components/voice-mic-input/voice-mic-input.component';
import { CsIconModule } from '@components/icon';

const VOICE_MIC_SELECTOR = 'voice-mic-input';

@Component({
  selector: 'app-quiz-text-answer',
  templateUrl: './quiz-text-answer.html',
  standalone: true,
  imports: [FormsModule, ButtonCtaComponent, VoiceMicInputComponent, CsIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuizTextAnswerComponent {
  readonly placeholder = input<string>('');
  readonly disabled = input<boolean>(false);
  readonly showVoice = input<boolean>(false);
  readonly valueChange = output<string>();

  readonly draft = signal<string>('');
  private readonly micInput = viewChild(VoiceMicInputComponent);

  constructor() {
    effect(() => {
      this.placeholder();
      this.draft.set('');
    });
  }

  onDraftChange(value: string): void {
    this.draft.set(value);
    this.valueChange.emit(value);
  }

  onTapToSpeak(event: MouseEvent): void {
    // clicks on the mic itself are handled by the mic component — avoid a double listen()
    if ((event.target as HTMLElement).closest(VOICE_MIC_SELECTOR)) return;
    this.micInput()?.onClick();
  }

  onVoiceTranscript(transcript: string): void {
    const current = this.draft().trim();
    const next = current ? `${current} ${transcript}` : transcript;
    this.onDraftChange(next);
  }
}
